import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";
import { InsightsAdvancedPayload } from "../../../commonTypes/insightAdvancedTypes";
import { getHeader } from "../../../constant/tableHeadersConstants/insightAdvancedConstants/insightAdvancedHeaderConst";
import { getInsightsAdvancedAction } from "../../../redux/insightsAdvanced/actions";
import {
  resetInsightAdvancedFetching,
  resetInsightAdvancedListData,
} from "../../../redux/insightsAdvanced";
import { RootState } from "../../../redux/rootReducers";

import {
  getCurrentFinancialYear,
  getLastFiveFinancialYears,
  previousFinancialYear,
  previousTwoFinancialYear,
} from "../../../utils/commonFunctions";
import { EmptyListPage, TableHeader, TableLoader } from "../../commons";

import MonthsData from "./DataList/MonthData";
import NameAndTrade from "./DataList/NameAndTrade";
import Yearly from "./DataList/Yearly";
import { dummyData } from "./dummyData";
import Select from "react-select";
import { monthlyLedgerReportTableHeader } from "./monthlyLedgerReportHeader";

type AppProps = {
  token: string | null;
  client_code: number | null;
  history: any;
  company_name: string | null;
  fetching: boolean;
  activeTab: string;
  insightAdvancedList: any;
  currencySign: string | undefined;
  dispatchInsightsAdvancedListData: (data: InsightsAdvancedPayload) => void;
  dispatchResetInsightAdvancedListData: () => void;
  dispatchResetInsightAdvancedFetching: () => void;
};

type DropDown = {
  label: string;
  value: string | null;
};

const InsightAdvancedList = ({
  token,
  client_code,
  history,
  company_name,
  fetching,
  activeTab,
  insightAdvancedList,
  currencySign,
  dispatchInsightsAdvancedListData,
  dispatchResetInsightAdvancedListData,
  dispatchResetInsightAdvancedFetching,
}: AppProps) => {
  const [changeYear, setChangeYear] = useState(true);
  const [headerDataArray, setHeaderDataArray] = useState<any>([]);
  const [showGraph, setShowGraph] = useState(false);
  const [selectYear, setSelectYear] = useState<DropDown>(
    getLastFiveFinancialYears()[0]
  );
  const [compareTo, setCompareTo] = useState<DropDown>({
    label: "Select...",
    value: null,
  });

  const filteredOptions = getLastFiveFinancialYears().filter(
    (option: DropDown) => !selectYear || option.value !== selectYear.value
  );

  useEffect(() => {
    setShowGraph(false);
    window.scroll(0, 0);
    setCompareTo({
      label: "Select...",
      value: null,
    });
    setSelectYear(getLastFiveFinancialYears()[0]);
    dispatchResetInsightAdvancedFetching();
    dispatchResetInsightAdvancedListData();
    if (token && client_code) {
      let final_data = {
        token,
        client_code,
        type: activeTab,
        start_FY: compareTo?.value ? compareTo?.value : selectYear?.value,
        end_FY: selectYear?.value,
      };
      dispatchInsightsAdvancedListData(final_data);
    }
  }, [activeTab]);

  useEffect(() => {
    setShowGraph(false);
    window.scroll(0, 0);
    setCompareTo({
      label: "Select...",
      value: null,
    });
    dispatchResetInsightAdvancedFetching();
    dispatchResetInsightAdvancedListData();
    if (token && client_code) {
      let final_data = {
        token,
        client_code,
        type: activeTab,
        start_FY: compareTo?.value ? compareTo?.value : selectYear?.value,
        end_FY: selectYear?.value,
      };
      dispatchInsightsAdvancedListData(final_data);
    }
  }, [selectYear?.value]);

  useEffect(() => {
    if (compareTo?.value) {
      setShowGraph(true);
      window.scroll(0, 0);
      dispatchResetInsightAdvancedFetching();
      dispatchResetInsightAdvancedListData();
      if (token && client_code) {
        let final_data = {
          token,
          client_code,
          type: activeTab,
          start_FY: compareTo?.value ? compareTo?.value : selectYear?.value,
          end_FY: selectYear?.value,
        };
        dispatchInsightsAdvancedListData(final_data);
      }
    } else {
      setShowGraph(false);
      window.scroll(0, 0);
      dispatchResetInsightAdvancedFetching();
      dispatchResetInsightAdvancedListData();
      if (token && client_code) {
        let final_data = {
          token,
          client_code,
          type: activeTab,
          start_FY: compareTo?.value ? compareTo?.value : selectYear?.value,
          end_FY: selectYear?.value,
        };
        dispatchInsightsAdvancedListData(final_data);
      }
    }
  }, [compareTo?.value]);

  useEffect(() => {
    if (insightAdvancedList?.length) {
      let headerData = insightAdvancedList[insightAdvancedList?.length - 1];
      let currentYearyLength =
        insightAdvancedList[0]?.current_year_monthly_data?.length;

      let dummyDataArray = dummyData?.slice(currentYearyLength);
      let finalData: any[] = [];
      if (
        dummyDataArray?.length &&
        insightAdvancedList[0]?.current_year_monthly_data?.length
      ) {
        finalData = [
          {
            ...insightAdvancedList[0],
            current_year_monthly_data: [
              ...insightAdvancedList[0]?.current_year_monthly_data,
              ...dummyDataArray,
            ],
          },
        ];
      }

      if (insightAdvancedList[0]?.current_year_monthly_data?.length > 0) {
        setHeaderDataArray(
          getHeader(finalData[finalData?.length - 1], changeYear, activeTab)
        );
      } else if (
        insightAdvancedList[0]?.current_year_monthly_data?.length === 0
      ) {
        let prevois_year = false;
        setHeaderDataArray(getHeader(headerData, prevois_year, activeTab));
      } else {
        setHeaderDataArray(getHeader(finalData, changeYear, activeTab));
      }
    }
  }, [insightAdvancedList]);

  const handleYear = () => {
    setChangeYear(!changeYear);
  };

  const handleDropChange = (e: DropDown) => {
    setSelectYear({
      label: e.label,
      value: e.value,
    });
    setCompareTo({
      label: "Select...",
      value: null,
    });
    // }
  };

  const handleCompareDropdownChange = (selectedOption: DropDown) => {
    setCompareTo(selectedOption);
  };

  const compareGraphModel = () => {
    setShowGraph((pre) => !pre);
  };

  return (
    <>
      <>
        <Row>
          <Col lg={7}>
            <div>
              <span>
                <div className="heading" style={{ marginBottom: "0px" }}>
                  Profit & Loss Statement
                </div>
                Below data is for a {""}
                {compareTo?.value && selectYear?.value
                  ? `FY ${selectYear?.value} and FY ${compareTo?.value}`
                  : `FY ${selectYear?.value && selectYear?.value}`}
                <br></br>
                {insightAdvancedList[0]?.current_year_monthly_data?.length ===
                  0 && (
                  <span className="text-danger" style={{ fontSize: "12px" }}>
                    Note: As the data in our systems gets updated on 30th of
                    every month. hence, the data from previous FY is currently
                    shown.
                  </span>
                )}
              </span>
            </div>
          </Col>
          <Col
            lg={5}
            className="text-right d-flex flex-row justify-content-end"
          >
            {
              <div className="mr-3 position-relative">
                <div className="mr-1" style={{ width: "130px" }}>
                  {insightAdvancedList[0]?.current_year_monthly_data?.length !==
                    0 && (
                    <label className="d-flex justify-content-start">
                      Select year
                    </label>
                  )}
                  <Select
                    value={selectYear}
                    options={getLastFiveFinancialYears()}
                    onChange={(e: any) => handleDropChange(e)}
                    isSearchable={false}
                    styles={{
                      option: (provided: any) => ({
                        ...provided,
                        textAlign: "center",
                      }),
                    }}
                  />
                </div>
              </div>
            }
            {
              <div
                className="mr-3 position-relative"
                style={{ width: "130px" }}
              >
                <label className="d-flex justify-content-start">
                  Compare to
                </label>
                <Select
                  value={compareTo}
                  options={[
                    { value: null, label: "Select..." },
                    ...filteredOptions,
                  ]}
                  onChange={(e: any) => handleCompareDropdownChange(e)}
                  isSearchable={false}
                  styles={{
                    option: (provided: any) => ({
                      ...provided,
                      textAlign: "center",
                    }),
                  }}
                />
              </div>
            }
          </Col>
        </Row>
        {fetching ? null : insightAdvancedList?.length ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "30% 40% 30%",
            }}
          >
            <div className="row" style={{ zIndex: 5 }}>
              <div className="col-md-12">
                <div className="table-bordered">
                  <table className="table table-striped">
                    <thead>
                      <TableHeader tableHeader={headerDataArray.slice(0, 2)} />
                    </thead>
                    <tbody>
                      <NameAndTrade
                        tableHeader={headerDataArray.slice(0, 2)}
                        changeYear={changeYear}
                        history={history}
                        data={insightAdvancedList}
                        preData={showGraph}
                        activeTab={activeTab}
                        currency={currencySign}
                        selectYear={selectYear?.value}
                        compareTo={compareTo?.value}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="row" style={{ overflowX: "scroll" }}>
              <div className="col-md-12">
                <div className="table-bordered">
                  <table className="table table-striped">
                    <thead>
                      <TableHeader
                        tableHeader={monthlyLedgerReportTableHeader(
                          selectYear?.value
                        )}
                      />
                    </thead>
                    <tbody>
                      <MonthsData
                        tableHeader={monthlyLedgerReportTableHeader(
                          selectYear?.value
                        )}
                        changeYear={changeYear}
                        history={history}
                        data={insightAdvancedList}
                        showGraph={showGraph}
                        client_code={client_code}
                        currencySign={currencySign}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-bordered">
                  <table className="table table-striped">
                    <thead>
                      <TableHeader
                        // textCenter
                        tableHeader={headerDataArray.slice(
                          headerDataArray?.length - 2,
                          headerDataArray?.length
                        )}
                      />
                    </thead>
                    <tbody>
                      <Yearly
                        tableHeader={headerDataArray.slice(
                          headerDataArray?.length - 2,
                          headerDataArray?.length
                        )}
                        changeYear={changeYear}
                        history={history}
                        data={insightAdvancedList}
                        client_code={client_code}
                        showGraph={showGraph}
                        currencySign={currencySign}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="p-5">
            <EmptyListPage title="No Data Found!" imageWidth="30%" />
          </div>
        )}
      </>

      {fetching && <TableLoader Rows={10} ColumnPerRow={8} />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.insightsAdvanced.fetching,
  insightAdvancedList: state.insightsAdvanced.insightsAdvancedListData,
  currencySign: state.auth.currencySign,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchInsightsAdvancedListData: (data: InsightsAdvancedPayload) =>
    dispatch(getInsightsAdvancedAction(data)),
  dispatchResetInsightAdvancedListData: () =>
    dispatch(resetInsightAdvancedListData()),
  dispatchResetInsightAdvancedFetching: () =>
    dispatch(resetInsightAdvancedFetching()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightAdvancedList);
